import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { FiltersComponent } from './filters.component';

@Component({
  selector: 'filter-list-multiple',
  templateUrl: './filter-list-multiple.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterListMultipleComponent<Name extends string, T> {
  constructor(
    private readonly filtersComponent: FiltersComponent<{ [K in Name]: T[] }>,
  ) {}

  @Input()
  name: Name;

  readonly selected = this.filtersComponent.value.pipe(
    map(value => value[this.name]),
  );

  changeSelected(value: T, selected: boolean) {
    this.filtersComponent.changeValue.next({
      name: this.name,
      reduce(selected_) {
        const set = new Set(selected_);
        if (selected) {
          set.add(value);
        } else {
          set.delete(value);
        }
        return [...set];
      },
    });
  }
}
